<div class="card-novo-sm">
  <a class="block no-underline cursor-pointer"
     [routerLink]="routerLink || null"
     (click)="!routerLink && onCardClick()">
    <div class="flex flex-col p-0 h-[220px]">
      <div [ngClass]="bgColor"
        class="flex-grow flex text-center items-center justify-center  rounded-t-[23px] h-7/10 w-5/5 overflow-visible">
        <mat-icon class="material-symbols-outlined icon-in-card" [ngClass]="textColor">{{icon}}</mat-icon>
      </div>
      <div class="flex items-center object-cover footer-card justify-center pt-2 h-3/10 rounded-b-[22px]">
        <h4>{{ title }}</h4>
      </div>
    </div>
  </a>
</div>
